<template>
  <div>
    <div>
      <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Client User List</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="4" class="my-1">
                  <label>Search</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    @input="debounceSearch"
                    v-model="Filter.common"
                    placeholder="Type to Search Client User Master and Code"
                    ref="search"
                  />
                </b-col>
                <b-col class="col-md-2">
                  <label>Branch</label>

                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="Filter.branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="debounceSearch"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-2">
                  <label>Created By</label>
                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllUserList']"
                    id="createdBy"
                    @input="debounceSearch"
                    v-model="Filter.createdBy"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Assigned User"
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-2"
                  ><label for="clientId">Status Type</label>
                  <model-list-select
                    :list="StatusTypeList"
                    id="StatusType"
                    v-model="Filter.StatusType"
                    option-value="val"
                    option-text="type"
                    placeholder="Status Type"
                    @input="debounceSearch"
                  ></model-list-select
                ></b-col>
                <b-col md="2">
                  <!-- <b-button
                    v-if="
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                    "
                    size="sm"
                    class="ml-1"
                    @click="getReports('ClientUser_Master_List')"
                    variant="outline-info"
                    >Export</b-button
                  > -->
                  <b-button
                    v-if="
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                    "
                    :disabled="ExcelBtnName != 'Export' ? true : false"
                    class="ml-1"
                    @click="getReports('ClientUser_Master_List', 'Export')"
                    size="sm"
                    variant="outline-info"
                    >{{ ExcelBtnName }}
                    <b-spinner
                      v-if="ExcelBtnName != 'Export'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>
                  <b-button
                    size="sm"
                    class="pull-left"
                    @click="AddClientUser()"
                    variant="primary"
                    >Add</b-button
                  >
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="ClientUserList"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                  responsive
                  primary-key="cu_id"
                  class="position-relative"
                >
                  <template slot="cu_id" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="multi_client_name" slot-scope="row1">
                    <span v-if="row1.item.multi_client_name">{{
                      row1.item.multi_client_name
                    }}</span
                    ><br />
                    <span v-if="row1.item.RaisedFrom"
                      >Raised From : {{ row1.item.RaisedFrom }}</span
                    ><br />
                  </template>
                  <template slot="cu_name" slot-scope="row2">{{
                    row2.item.cu_name
                  }}</template>
                  <template slot="email" slot-scope="row3">{{
                    row3.item.email
                  }}</template>
                  <template slot="contact" slot-scope="row4">{{
                    row4.item.contact
                  }}</template>
                  <template slot="address" slot-scope="row5">
                    <span v-if="row5.item.address">
                      Address : {{ row5.item.address }}
                      <br />
                    </span>
                  </template>
                  <template slot="is_active" slot-scope="row6">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row6.item.cu_id">
                      <md-switch
                        :id="'approval' + row6.item.cu_id"
                        name="approval"
                        class="md-primary"
                        :value="row6.item.is_active == 1 ? true : false"
                        @change="activateUser(row6.item)"
                      >
                        <h6>
                          <br />
                          <b-badge
                            :variant="row6.item.is_active == 1 ? 'success' : 'danger'"
                            >{{
                              row6.item.is_active == 1 ? "Active" : "In-Active"
                            }}</b-badge
                          >
                        </h6>
                      </md-switch>
                    </div>
                  </template>
                  <template slot="is_approve" slot-scope="row7">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row7.item.cu_id">
                      <md-switch
                        :id="'approval' + row7.item.cu_id"
                        name="approval"
                        class="md-primary"
                        :value="row7.item.is_approve == 1 ? true : false"
                        @change="approveUser(row7.item)"
                      >
                        <h6>
                          <br />
                          <b-badge
                            :variant="row7.item.is_approve == 1 ? 'success' : 'danger'"
                            >{{
                              row7.item.is_approve == 1 ? "Approve" : "Pending"
                            }}</b-badge
                          >
                        </h6>
                      </md-switch>
                    </div>
                  </template>
                  <template slot="created_at" slot-scope="row8">
                    <span v-if="row8.item.created_at">
                      Created : {{ row8.item.created_at }}
                      <br />
                    </span>
                    <span v-if="row8.item.createdBy">
                      Created By : {{ row8.item.createdBy }}
                      <br />
                    </span>
                    <span v-if="row8.item.updated_at">
                      Updated : {{ row8.item.updated_at }}
                      <br />
                    </span>
                    <span v-if="row8.item.updatedBy">
                      Updated By : {{ row8.item.updatedBy }}
                      <br />
                    </span>
                  </template>

                  <template slot="action" slot-scope="row9">
                    <b-button
                      variant="outline-primary"
                      style="font-size: 0.675rem"
                      @click="editClientUser(row9.item)"
                      id="addButtonLoader"
                      size="sm"
                      >Update</b-button
                    >
                    <b-button
                      variant="outline-primary"
                      style="font-size: 0.675rem"
                      @click="SendClientUser(row9.item)"
                      id="addButtonLoader"
                      size="sm"
                      >Approve</b-button
                    >
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="25"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
      if (globalPermissionStatus("Client User") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Client User")
        );
        globalPermissionStatus("Client User");
        this.$store.dispatch("setCurrentRoute", "/client/user");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getData();
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export",
      adminToggle: this.$sessionsStorage.get("designation"),
      isLoading: false,
      fields: [
        {
          key: "cu_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "multi_client_name",
          label: "Company",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "cu_name",
          label: "Client",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "contact",
          label: "Mobile",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_approve",
          label: "Approve",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_at",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      Filter: { common: "", branchfilter: "", createdBy: "", StatusType: "" },
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      validate: true,
      ClientUserList: [],
      StatusTypeList: [
        {
          type: "Rejected",
          val: "3",
        },
        {
          type: "Pending",
          val: "2",
        },
        {
          type: "Approve",
          val: "1",
        },
      ],
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    MultiSelect,
  },

  computed: {},
  methods: {
    goBack() {
      window.history.go(-1);
    },
    editClientUser(item) {
      console.log("Item=>", item);
      this.$sessionsStorage.set("edit_cu_id", item.cu_id);
      this.$router.push({
        path: "/client/user/upsertClientUser",
      });
    },
    activateUser(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.is_active = this.itemObj.is_active == 1 ? 0 : 1;
      let paylod = {
        tableName: "client_user_master",
        tableId: "cu_id",
        tableIsActive: "is_active",
        value1: this.itemObj.is_active,
        tableVal: item.cu_id,
        isMailSend:'No',
        manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    approveUser(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.is_approve = this.itemObj.is_approve == 1 ? 0 : 1;
      let paylod = {
        tableName: "client_user_master",
        tableId: "cu_id",
        tableIsActive: "is_approve",
        value1: this.itemObj.is_approve,
        tableVal: item.cu_id,
        isMailSend:'No',
         manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    approveUser_bak(item) {
      if (item.cu_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "Send_Approval_Mail",
          clientUserForm: item,
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          ClientUserService.getAllClientUserList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.cu_id != "" && data.cu_id != undefined) {
                if (data.find == 1 || data.find == 2) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                }
                if (data.flag == true) {
                  this.$router.push({
                    path: "/client/user",
                  });
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
            })
            .catch((error) => {
              console.log("Catch on Proforma Error: ", error);
            });
        }
      }
    },
    AddClientUser() {
      this.$sessionsStorage.set("edit_cu_id", "");
      this.$router.push({
        path: "/client/user/upsertClientUser",
      });
    },
    getReports(id, btnName) {
      let payload = {
        excelId: id,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        this.ExcelBtnName = btnName;
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    activateClientUserMaster() {
      if (
        this.ClientUserMaster.is_active == 1 ||
        this.ClientUserMaster.is_active == true
      ) {
        this.ClientUserMaster.is_active = false;
      } else if (
        this.ClientUserMaster.is_active == 0 ||
        this.ClientUserMaster.is_active == false
      ) {
        this.ClientUserMaster.is_active = true;
      }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getData();
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.Filter = { common: "", branchfilter: "", createdBy: "", StatusType: "" };
      this.getData();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {},

    getData() {
      this.isLoading = true;
      let payload = {
        itemCode: "ALL_Client_Users",
        searchVal: this.filter,
        Filter: this.Filter,
      };
      ClientUserService.getAllClientUserList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.ClientUserList = data.ClientUserList;
            this.totalRows = data.ClientUserList.length;
            console.log(" ClientUser List response=>", data);
          } else {
            this.ClientUserList = [];
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on ClientUser List Error: ", error);
        });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// clientUserList.vue?db645188